<template>
  <div :style="{width: width, height: height}">
    <el-image :style="{width: width, height: height}" style="cursor: pointer;" :src="url" fit="fill" v-if="url" @click="funClick"></el-image>
    <ImageOpenDialog :currentMarker="dialogConfig" :direction="chartConfig.direction" :dialogWidth="chartConfig.dialogWidth" ref="mainImage"></ImageOpenDialog>
    <el-dialog custom-class="customDialogClass"    :append-to-body="true" :width="getDialogWidth" :visible.sync="dialogFrameVisible">
      <div slot="title" class="title">{{chartConfig.formTitle}}</div>
      <div>
          <iframe :src="chartConfig.btnLocation" :height="getDialogHeight" width="100%" border="none" frameborder="no"></iframe>
      </div>

    </el-dialog>
  </div>
</template>
<style>
</style>
<script>
  import fwUtil from 'framework-util'
  import ImageOpenDialog from '../../ImageOpenDialog.vue'
  export default {
    components: {
      ImageOpenDialog
    },
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            uploadUrl: '',
            authorization: '',
            imageId: '',
            isOpen: '0',
            formTitle: '窗口',
            list: [],
            btnLocation: null,
            dialogWidth:'500px',
            dialogHeight:'500px',
            frameworkUrl:'',
            image: null
          }
        }
      }
    },
    mounted() {
      this.getUrl()
    },
    computed: {
      getDialogWidth() {
        let _width = this.chartConfig.dialogWidth ? this.chartConfig.dialogWidth : "500px"
        let tempWidth=_width.replace("px", "");
        tempWidth = parseInt(tempWidth)
        let height = tempWidth / this.page.width * this.screen.width
        return height + 'px'
      },
      getDialogHeight() {
        let _width = this.chartConfig.dialogHeight ? this.chartConfig.dialogHeight : "500px"
        let tempWidth=_width.replace("px", "");
        tempWidth = parseInt(tempWidth)
        let height = tempWidth / this.page.height * this.screen.height
        return height + 'px'
      },
    },
    watch: {
      chartConfig: {
        handler(newValue, oldValue) {
          this.dialogConfig.title = this.chartConfig.formTitle,
            this.dialogConfig.list = this.chartConfig.list,
            this.dialogConfig.image = this.chartConfig.image
          this.getUrl()
        },
        deep: true
      },
    },
    data() {
      return {
        url: null,
        dialogFrameVisible:false,
        dialogConfig: {
          title: this.chartConfig.formTitle,
          list: this.chartConfig.list,
          image: this.chartConfig.image
        }
      }
    },
    methods: {
      getUrl() {
        if (this.chartConfig && this.chartConfig.imageId) {
          fwUtil.CommonUtil.getImagePathService(this.chartConfig.imageId).then((res) => {
            this.url = res
          })
        }
      },

      funClick() {
        if (this.chartConfig.isOpen) {
          if (this.chartConfig.isOpen == '2') {
            if (this.chartConfig.btnLocation) {
              window.location.href = this.chartConfig.btnLocation
            }
          } else if (this.chartConfig.isOpen == '1') {
            this.$refs.mainImage.show()
          }else if(this.chartConfig.isOpen=='3'){//弹窗显示第三方URL
            this.dialogFrameVisible=true;
          }
        }
      }
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/images/image/components/images.vue